<div style="position: relative">
  <mat-progress-bar
    *ngIf="fieldStillLoading > 0"
    mode="buffer"
  ></mat-progress-bar>

  <div id="new-message-header" class="mat-typography">
    <h3 id="new-message-form-title"></h3>
    <mat-icon aria-hidden="false" id="exit-form-control" (click)="closeDialog()"
      >close</mat-icon
    >
  </div>

  <div id="new-message-container">
    <form
      [formGroup]="jobForm"
      (ngSubmit)="onSubmit()"
      id="new-message-form-container"
    >
      <h4 class="pt-2">Generali:</h4>
      <div id="sender-container">
        <mat-form-field name="sender" ngDefaultControl class="sender-field">
          <mat-label>Selezionare il mittente certificato:</mat-label>
          <mat-select
            formControlName="sender"
            required
            (selectionChange)="senderSelected($event.value)"
          >
            <mat-select-trigger *ngIf="selectedSender">
              {{ selectedSender.name }}
            </mat-select-trigger>
            <mat-option
              class="sender-container"
              *ngFor="let sender of senders"
              [value]="sender"
              [disabled]="getContractStatus(sender) == 2"
            >
              {{ sender.name }}
              <mat-icon
                *ngIf="getContractStatus(sender) == 1"
                class="contract-alert-icon"
                [inline]="true"
                matTooltip="Attenzione, il contratto è in scadenza."
                aria-hidden="false"
                aria-label="Icona alert contratto in scadenza"
                >warning</mat-icon
              >
              <mat-icon
                *ngIf="getContractStatus(sender) == 2"
                class="contract-error-icon"
                [inline]="true"
                matTooltip="Attenzione, il contratto è scaduto."
                aria-hidden="false"
                aria-label="Icona alert contratto in scadenza"
                >warning</mat-icon
              >
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div *ngIf="selectedSender" id="category-container">
        <mat-form-field name="category" ngDefaultControl class="category-field">
          <mat-label>Selezionare la categoria del messaggio:</mat-label>
          <mat-select formControlName="category" required>
            <mat-option
              *ngFor="let category of categories"
              [value]="category.categoryCode"
            >
              {{ category.category }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div *ngIf="selectedSender" id="aree-container">
        <h4 class="mt-3 mb-2">Modalità di invio:</h4>
        <mat-radio-group
          aria-label="Select an option"
          (change)="changeSendingMode($event.value)"
          formControlName="sendingMode"
        >
          <mat-radio-button [value]="'aree'" [checked]="true"
            >aree</mat-radio-button
          >
          <mat-radio-button [value]="'lista'" class="ml-3"
            >lista di distribuzione</mat-radio-button
          >
        </mat-radio-group>

        <mat-form-field
          *ngIf="chosenSendingMode == 'aree'"
          name="aree"
          ngDefaultControl
          class="aree-field"
        >
          <mat-label>Selezionare le aree di interesse:</mat-label>
          <mat-select multiple formControlName="aree">
            <mat-option *ngFor="let area of aree" [value]="area.id">
              {{ area.area }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <ng-container *ngIf="chosenSendingMode == 'lista'">
          <mat-form-field name="lista" ngDefaultControl class="aree-field">
            <mat-label>Selezionare la lista di distribuzione:</mat-label>
            <mat-select formControlName="lista">
              <mat-option
                *ngFor="let lista of liste"
                [value]="lista.distListDTO.id"
              >
                {{ lista.distListDTO.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-radio-group formControlName="chatEnabled">
            <mat-radio-button [value]="1" [checked]="true"
              >Chat abilitata</mat-radio-button
            >
            <mat-radio-button [value]="0" class="ml-3"
              >Chat disabilita</mat-radio-button
            >
          </mat-radio-group>
        </ng-container>
        <!-- <pre>Selected time: {{time | json}}</pre> -->
      </div>

      <mat-expansion-panel
        *ngIf="this.jobForm.value.aree && this.jobForm.value.aree.length > 0"
        (opened)="
          panelOpenState = true; this.agmMap.adjustBounds(this.areeToShow)
        "
        (closed)="panelOpenState = false"
        [expanded]="panelOpenState"
      >
        <mat-expansion-panel-header>
          <mat-panel-title> Mostra mappa </mat-panel-title>
        </mat-expansion-panel-header>
        <app-detail-map-v2 [aree]="this.areeToShow"></app-detail-map-v2>
      </mat-expansion-panel>

      <div formGroupName="messageCore">
        <!-- <hr> -->
        <h4 class="mt-3 mb-1 py-2">Dettagli:</h4>

        <mat-form-field appearance="fill" class="subject-field">
          <mat-label>Oggetto:</mat-label>
          <input
            matInput
            type="text"
            formControlName="subject"
            maxlength="50"
            #subjectDescription
            required
          />
          <small class="form-text text-muted"
            ><code>{{ subjectDescription.value.length }}</code> di
            <code>{{ 50 }}</code> caratteri</small
          >
        </mat-form-field>

        <mat-form-field appearance="fill" class="body-field">
          <mat-label>Testo del Messaggio:</mat-label>
          <textarea
            matInput
            formControlName="body"
            maxlength="600"
            #bodyDescription
            cdkTextareaAutosize
            #autosize="cdkTextareaAutosize"
            cdkAutosizeMinRows="1.5"
            cdkAutosizeMaxRows="50"
            required
          ></textarea>
          <small class="form-text text-muted"
            ><code>{{ bodyDescription.value.length }}</code> di
            <code>{{ 600 }}</code> caratteri</small
          >
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Allegato</mat-label>
          <ngx-mat-file-input
            (change)="checkFile($event.target.files[0]); fileNameError($event)"
            formControlName="file"
            placeholder="File allegati"
            class="font-size-16"
            [accept]="mimesAllowed"
          ></ngx-mat-file-input>
          <mat-icon matSuffix>folder</mat-icon>
          <mat-error
            *ngIf="
              jobForm.get('messageCore.file').hasError('maxContentSize') &&
              !fileNotSupported
            "
          >
            Errore: La dimensione totale non deve superare
            {{
              jobForm.get("messageCore.file")?.getError("maxContentSize")
                .maxSize | byteFormat
            }}
            ({{
              jobForm.get("messageCore.file")?.getError("maxContentSize")
                .actualSize | byteFormat
            }}).
          </mat-error>
          <mat-error *ngIf="fileNotSupported">
            Errore: Tipo file non supportato.
          </mat-error>
          <mat-error *ngIf="fileRequired">
            Errore: File obbligatorio.
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="link-field">
          <mat-label>Link</mat-label>
          <input
            matInput
            type="url"
            formControlName="link"
            #linkDescription
            pattern="^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$"
          />
          <!-- <small class="form-text text-muted"><code>{{subjectDescription.value.length}}</code> of <code>{{50}}</code>
            characters</small> -->
          <mat-error
            *ngIf="jobForm.get('messageCore.link').hasError('pattern')"
          >
            Errore: Link non valido.
            <!-- ({{jobForm.get('messageCore.link')?.getError('maxlength').requiredLength}} caratteri) -->
          </mat-error>
          <mat-error
            *ngIf="jobForm.get('messageCore.link').hasError('maxlength')"
          >
            Errore: La lunghezza del link supera il massimo consentito.
            <!-- ({{jobForm.get('messageCore.link')?.getError('maxlength').requiredLength}} caratteri) -->
          </mat-error>
        </mat-form-field>
        <mat-error *ngIf="isFileNameIncorrect"
          >Attenzione: il nome del file non può contenere ".."</mat-error
        >
      </div>

      <!-- <hr> -->

      <div formGroupName="times" name="times">
        <div class="dateTime-container">
          <mat-form-field class="inizio-date-field">
            <mat-label>Inizio validità</mat-label>
            <input
              matInput
              formControlName="inizio"
              [matDatepicker]="picker1"
              required
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="picker1"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
          </mat-form-field>
          <ngx-timepicker-field
            class="inizio-time-field"
            [format]="24"
            [controlOnly]="true"
            [defaultTime]="'00:00'"
            formControlName="inizio_tempo"
            required
          ></ngx-timepicker-field>
        </div>

        <div class="dateTime-container">
          <mat-form-field class="scadenza-date-field">
            <mat-label>Scadenza</mat-label>
            <input
              matInput
              formControlName="scadenza"
              [matDatepicker]="picker2"
              required
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="picker2"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker2></mat-datepicker>
          </mat-form-field>
          <ngx-timepicker-field
            class="scadenza-time-field"
            [format]="24"
            [controlOnly]="true"
            [defaultTime]="'23:59'"
            formControlName="scadenza_tempo"
            required
          ></ngx-timepicker-field>
        </div>
      </div>

      <mat-form-field appearance="outline">
        <mat-label>Prezzo</mat-label>
        <mat-select
          formControlName="idPrezzo"
          required
          (selectionChange)="senderPrice($event.value)"
        >
          <mat-option *ngFor="let item of listaPrezzo" [value]="item.id">
            {{ item.prezzo | currency : "EUR" : true }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!--  <mat-form-field appearance="outline">
        <mat-label>Prezzo</mat-label>
        <input matInput type="number" formControlName="prezzo"> -->
      <!-- <small class="form-text text-muted"><code>{{subjectDescription.value.length}}</code> of <code>{{50}}</code>
          characters</small> -->
      <!--   <mat-error *ngIf="jobForm.get('messageCore.link').hasError('pattern')">
          Errore: Link non valido. -->
      <!-- ({{jobForm.get('messageCore.link')?.getError('maxlength').requiredLength}} caratteri) -->
      <!--  </mat-error> -->
      <!-- <mat-error *ngIf="jobForm.get('prezzo').hasError('pattern')">
          Errore: non puoi inserire una cifra inferiore allo 0 -->
      <!-- ({{jobForm.get('messageCore.link')?.getError('maxlength').requiredLength}} caratteri) -->
      <!--  </mat-error> -->
      <!-- </mat-form-field> -->

      <!-- <div id="dateTime-container2">
        <owl-date-time-inline id="inizio-validità-container"></owl-date-time-inline>
        <owl-date-time-inline id="scadenza-container"></owl-date-time-inline>
      </div> -->

      <!-- Sezione errori jobform.times -->
      <div
        *ngIf="
          jobForm.get('times').errors &&
          (jobForm.get('times').dirty || jobForm.get('times').touched)
        "
        class="alert alert-danger"
      >
        <div *ngIf="jobForm.get('times').errors.invalidStartDate">
          Errore: Data e ora di inizio validità devono essere posteriori alla
          data e ora attuali.
        </div>
        <div *ngIf="jobForm.get('times').errors.invalidEndDate">
          Errore: Il periodo di validità deve essere di almeno un'ora.
        </div>
        <div *ngIf="jobForm.get('times').errors.forbiddenName">
          Name cannot be Bob.
        </div>
      </div>
      <!-- <pre>Selected time: {{time | json}}</pre> -->

      <!-- <hr> -->

      <!-- <button type="submit" [disabled]="!jobForm.valid">Invia</button> -->
      <button
        mat-flat-button
        type="submit"
        [disabled]="!jobForm.valid || isFileNameIncorrect"
        id="whereapp-submit-button"
        color="primary"
      >
        Invia
      </button>

      <!-- <p>
            Form Status: {{ jobForm.status }}
        </p> -->
    </form>
    <div class="loading" *ngIf="sub === true"></div>
  </div>

  <!-- <mat-spinner class="spinner" *ngIf="sub === true"></mat-spinner> -->
</div>
